import Alert from "shared/components/utils/icons/Alert";
import Button from "shared/components/inputs/mui/Button";
import IconButton from "shared/components/inputs/button/IconButton";
import Link from "shared/components/navigation/links/AnchorLink";
import Loading from "shared/components/feedback/loading/Loading";
import PropTypes from "prop-types";
import { useAllocations as allocationServiceLayer } from "features/allocations/api/useAllocations";
import env from "react-dotenv";
import moment from "moment";
import { useEmailError } from "shared/hooks/errors/useEmailError";
import { useState } from "react";
import { useTestConnection } from "shared/hooks/useTestConnection";
import {
    Icon,
    Content,
    ErrorDetail,
    Header,
    Body,
    Footer,
    Wrapper,
    Buttons,
} from "./SaveHoursErrorModal.styles";

const getTransactionId = (transactionId) => {
    if (transactionId) {
        const split = transactionId.split("-");
        return split[split.length - 1];
    }
};

const TRY_AGAIN_CODE_RESPONSES = JSON.parse(
    env.BESTWORK_REACT_ALLOCATIONS_TRYAGAIN_SAVE_CODES
);

const SaveHoursErrorModal = ({
    projectName,
    dates,
    initialError,
    onCancel,
    parameters,
    resetCells,
    cells,
    onClose,
}) => {
    const { saveAllocationsHours } = allocationServiceLayer();
    const [error, setError] = useState(initialError);
    const [loading, setLoading] = useState(false);
    const handleClose = () => {
        onCancel();
    };

    const { sendEmail } = useEmailError();
    const { testConnection } = useTestConnection();

    const handleClick = () => {
        sendEmail(initialError);
    };

    const handleTestConnection = async () => {
        const rv = await testConnection();
        alert(rv);
    };

    const handleTryAgain = async () => {
        setLoading(true);
        try {
            await saveAllocationsHours(parameters);
            resetCells(cells);
            onClose();
        } catch (e) {
            setError(e);
            setLoading(false);
        }
    };

    return (
        <Wrapper>
                <IconButton></IconButton>
                <Icon>
                    <Alert size="25" viewBox="18" />
                </Icon>
                <Header>Something Went Wrong</Header>
                <Body>
                    <Content>
                        <p>
                            Sorry, we couldn’t save the changes to{" "}
                            <b>{projectName}</b> for the week(s) of{" "}
                            <b>{dates}</b>. Please try again.
                        </p>
                        <p>
                            If the problem persists please report this error to{" "}
                            <b>{globalThis.config.mails.support}</b>. Please include
                            the details below, and a description of the query
                        </p>
                        <ErrorDetail>
                            <p>
                                Date:{" "}
                                {error.date
                                    ? moment(error.date).format(
                                        "MMMM Do YYYY, h:mm:ss a"
                                    )
                                    : "Unknown"}
                            </p>
                            <p>
                                Error code:{" "}
                                {loading ? "Unknown" : error.status}
                            </p>
                            <p>
                                Transaction ID:{" "}
                                {loading
                                    ? "Unknown"
                                    : getTransactionId(error.correlationId)}
                            </p>
                        </ErrorDetail>
                    </Content>
                </Body>
                <Footer>
                    <Buttons>
                        {TRY_AGAIN_CODE_RESPONSES.includes(error?.status) ? (
                            <>
                                <Link
                                    variant="secondary"
                                    onClick={() => handleClose()}
                                    style={{ alignSelf: "center" }}
                                >
                                    Cancel
                                </Link>

                                <Button
                                    style={{
                                        width: "11rem",
                                        height: "2.8rem",
                                        alignSelf: "center",
                                    }}
                                    onClick={() => handleTryAgain()}
                                >
                                    {loading ? (
                                        <Loading
                                            background={
                                                globalThis.config.colors.black
                                            }
                                            color={globalThis.config.colors.white}
                                        />
                                    ) : (
                                        <>Try Again</>
                                    )}
                                </Button>
                            </>
                        ) : (
                            <>
                                <Button
                                    style={{ width: "11rem" }}
                                    onClick={handleClick}
                                >
                                    Email Support
                                </Button>
                                <Button
                                    style={{ width: "11.75rem" }}
                                    onClick={handleTestConnection}
                                >
                                    Test Connection
                                </Button>
                            </>
                        )}
                    </Buttons>
                </Footer>
        </Wrapper>
    );
};

SaveHoursErrorModal.propTypes = {
    projectName: PropTypes.string.isRequired,
    dates: PropTypes.string.isRequired,
    initialError: PropTypes.shape({
        date: PropTypes.string,
        status: PropTypes.number,
        correlationId: PropTypes.string,
    }).isRequired,
    onCancel: PropTypes.func.isRequired,
    parameters: PropTypes.object.isRequired,
    resetCells: PropTypes.func.isRequired,
    cells: PropTypes.array.isRequired,
    onClose: PropTypes.func.isRequired,
};

export default SaveHoursErrorModal;
